var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "row py-3",
      staticStyle: { "background-color": "white", width: "99.85%" }
    },
    [
      _c(
        "div",
        {
          staticClass: "col-md-2 col-sm-12 col-spacing student-spacing center"
        },
        [
          _c("div", { staticClass: "data-name" }, [_vm._v(" Edad: ")]),
          _c("div", { staticClass: "font-weight-normal color-black" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.additionalInfo !== null && _vm.additionalInfo.age !== null
                    ? _vm.additionalInfo.age
                    : "-"
                ) +
                " "
            )
          ])
        ]
      ),
      _c(
        "div",
        { staticClass: "col-md-2 col-sm-12 col-spacing student-spacing" },
        [
          _c("div", { staticClass: "data-name" }, [
            _vm._v(" Tipo de Escuela: ")
          ]),
          _c("div", { staticClass: "font-weight-normal color-black" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.additionalInfo !== null &&
                    _vm.additionalInfo.schoolType !== null
                    ? _vm.additionalInfo.schoolType
                    : "-"
                ) +
                " "
            )
          ])
        ]
      ),
      _c(
        "div",
        { staticClass: "col-md-2 col-sm-12 col-spacing student-spacing" },
        [
          _c("div", { staticClass: "data-name" }, [_vm._v(" Grupo de Edad: ")]),
          _c("div", { staticClass: "font-weight-normal color-black" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.additionalInfo !== null &&
                    _vm.additionalInfo.ageGroup !== null
                    ? _vm.additionalInfo.ageGroup
                    : "-"
                ) +
                " "
            )
          ])
        ]
      ),
      _c(
        "div",
        { staticClass: "col-md-4 col-sm-12 col-spacing student-spacing" },
        [
          _c("div", { staticClass: "data-name" }, [
            _vm._v(" Número de Grant: ")
          ]),
          _c(
            "div",
            { staticClass: "font-weight-normal color-black" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-drop-down", {
                          attrs: {
                            clearable: false,
                            "custom-error-msg":
                              "Favor de seleccionar una cifra de cuenta.",
                            disabled:
                              _vm.additionalInfo.checkedFlag && !_vm.editing,
                            error: errors[0],
                            fieldkey: "id",
                            fieldname: "name",
                            options: _vm.purchaseOrders,
                            placeholder: "Seleccione"
                          },
                          model: {
                            value: _vm.selectPurchaseOrder,
                            callback: function($$v) {
                              _vm.selectPurchaseOrder = $$v
                            },
                            expression: "selectPurchaseOrder"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ]
      ),
      _vm.canEdit
        ? _c(
            "div",
            {
              staticClass: "col-md-2 col-sm-12 col-spacing student-spacing mt-4"
            },
            [
              !_vm.editing
                ? _c("action-button", {
                    attrs: { i: "far fa-edit", variant: "success mx-2" },
                    on: {
                      click: function($event) {
                        return _vm.editNumber()
                      }
                    }
                  })
                : _vm._e(),
              _vm.editing
                ? _c("action-button", {
                    attrs: {
                      i: "fas fa-times-circle",
                      variant: "outline-danger mx-2"
                    },
                    on: {
                      click: function($event) {
                        return _vm.cancel()
                      }
                    }
                  })
                : _vm._e(),
              _vm.editing
                ? _c("action-button", {
                    staticClass: "success",
                    attrs: { i: "far fa-save", variant: "success mx-2" },
                    on: {
                      click: function($event) {
                        return _vm.saveChange()
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      !_vm.isValidGrant
        ? _c("error", {
            staticClass: "pt-2 ml-2",
            attrs: {
              "is-alert-mode": "",
              message:
                "La cifra de cuenta seleccionada no corresponde a este servicio. Te recomendamos verificar y seleccionar la cifra correcta.",
              variant: "no-border"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }